import { getErpPermissions } from "../erpClient";

export const WHATSAPP_PERMISSION_CODES = {
  WHATSAPP: "WHATSAPP",
  INBOX: "WHATSAPP_INBOX",
  PHONEBOOK: "WHATSAPP_PHONEBOOK",
  CAMPAIGN: "WHATSAPP_CAMPAIGN",
  DASHBOARD: "WHATSAPP_DASHBOARD",
  TEMPLATE: "WHATSAPP_TEMPLATE",
};

const WHATSAPP_SUB_CODES = [
  WHATSAPP_PERMISSION_CODES.INBOX,
  WHATSAPP_PERMISSION_CODES.PHONEBOOK,
  WHATSAPP_PERMISSION_CODES.CAMPAIGN,
  WHATSAPP_PERMISSION_CODES.DASHBOARD,
  WHATSAPP_PERMISSION_CODES.TEMPLATE,
];

export function hasWhatsAppPerm(permissions, code) {
  if (!permissions) return false;
  if (permissions.WHATSAPP === 1) return true;
  return permissions[code] === 1;
}

/** WhatsApp access from permissions map only (no role-name bypass). */
export function hasWhatsAppPermission(code) {
  return hasWhatsAppPerm(getErpPermissions(), code);
}

export function hasAnyWhatsAppAccess() {
  const perms = getErpPermissions();
  if (!perms) return false;
  if (perms.WHATSAPP === 1) return true;
  return WHATSAPP_SUB_CODES.some((code) => perms[code] === 1);
}

/** First allowed WhatsApp route for /whatsapp redirect. */
export function getDefaultWhatsAppPath() {
  if (hasWhatsAppPermission(WHATSAPP_PERMISSION_CODES.DASHBOARD)) {
    return "/whatsapp/dashboard";
  }
  if (hasWhatsAppPermission(WHATSAPP_PERMISSION_CODES.PHONEBOOK)) {
    return "/whatsapp/phonebooks";
  }
  if (hasWhatsAppPermission(WHATSAPP_PERMISSION_CODES.TEMPLATE)) {
    return "/whatsapp/templates";
  }
  if (hasWhatsAppPermission(WHATSAPP_PERMISSION_CODES.CAMPAIGN)) {
    return "/whatsapp/campaigns";
  }
  if (hasWhatsAppPermission(WHATSAPP_PERMISSION_CODES.INBOX)) {
    return "/whatsapp/inbox";
  }
  return null;
}
